import { Component } from "@angular/core";
import { UserService } from "../../services/UserService";
import { ProductService } from "../../services/ProductService";
import { Subscription } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { MdSnackBar, MdDialog, MdRadioChange } from "@angular/material";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { IUserRights } from "../../interfaces/UserRights";
import "rxjs/Rx";
import { AdalService } from "../../shared/adal.service";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";
import swal from "sweetalert2";
import { LicenseService } from "../../services/LicenseService";
import { PortalAccess } from "../../interfaces/LicenseModel";
import Swal from "sweetalert2";

@Component({
  selector: "my-page-layout-add-user",
  styles: [],
  template: require('./adduser.component.html'),
})
export class PageLayoutaddUserComponent {
  private sub: Subscription;
  resultData: any;
  IsAdmin: any;
  productData;
  productAdd = false;
  productDelete = false;
  productApprove = false;
  errorMessage: string;
  submitted = false;
  validationForm: FormGroup;
  chkAllProduct = false;
  flagInstrument = false;
  UserId: number;
  selected: any;
  Oldselected: any = 1;
  loggeduserrole: number = Number(localStorage.getItem("role"));
  OTARights;
  portalAccess;
  LicensingRights;
  LicenseRole=0;
  isProductRightsColumnExpanded;
  isLicenseRightsColumnExpanded;
  licenseProducts;
  licenseRightsArray=[];
  items: any = [
    {
      label: "Developer",
      value: 1,
    },
    {
      label: "QA",
      value: 2,
    },
    {
      label: "Product Management",
      value: 3,
    },
  ];

  radioChange(event: MdRadioChange) {
    let role = "";

    if (event.value == 1) {
      role = "Developer";
    } else if (event.value == 2) {
      role = "QA";
    } else {
      role = "Product Management";
    }

    this.selected = event.value;
    swal
      .fire({
        title: "<strong>User Role Change</strong>",
        icon: "info",
        html:
          `
        <p>You are about to grant ` +
          this.validationForm.value.Name.trim() +
          ` ` +
          role +
          ` access.</p>
        <p><b>Are you sure want to continue?</b></p>
        `,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: `Continue`,
        confirmButtonAriaLabel: "Continue",
        cancelButtonText: `Cancel`,
        cancelButtonAriaLabel: "Cancel",
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.Oldselected = this.selected;

          // Reset all rights
          // this.productData.forEach((element) => {
          //
          //   element.isDirtyAddchecked = false;
          //   element.isDirtyActiveInactiveChecked = false;
          //   element.isDirtyApprovechecked = false;

          //   element.Addchecked = false;
          //   element.Approvechecked = false;
          //   element.ActiveInactiveChecked = false;

          // });
        } else if (result.isDismissed) {
          this.selected = this.Oldselected;
        }
      });
    //this.filter['property'] = this.selected;
    //console.log(this.filter);
  }

  constructor(
    public dialog: MdDialog,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public snackBar: MdSnackBar,
    private appLoaderService: AppLoaderService,
    private productService: ProductService,
    private adalService: AdalService,
    private userService: UserService,
    private licenseService:LicenseService
  ) {
    // Check Authentication
    if (!this.adalService.getCachedToken()) {
      this.router.navigate(["login"]);
    }
    this.getInstrument();
    this.getLicenseProducts();
  }

  ngOnInit(){
    this.sub = this.route.params.subscribe((params) => {
      this.UserId = params["id"];
      if (this.UserId == 0) {
        this.UserId = 0;
        this.chkAllProduct = false;
      }
      if (this.UserId != 0) {
        this.getUserDetail(this.UserId);
        this.getUserAllRights(this.UserId);
        // this.userRights(this.UserId);
      }
      this.buildForm();
    });

    if (this.UserId != 0) {
      // this.userRights(this.UserId);
      this.getUserAllRights(this.UserId);
    }
  }
  userRightsArray: Array<IUserRights> = [];
  newDynamicInstrument: any = {};

  buildForm() {
    this.validationForm = this.formBuilder.group({
      Name: [
        "",
        [Validators.required, Validators.pattern("\\S[a-zA-Z ]{2,50}$")],
      ],
      EmailId: [
        "",
        [
          Validators.required,
          Validators.email,
          Validators.pattern(
            "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
          ),
        ],
      ],
      IsAdmin: false,
      Role:1,
      OTARights:false,
      LicensingRights:false,
    });
  }

  OTARightsChange(event){
    if(event.checked){
      this.OTARights=true;
      this.selected=1 //by default developer role would be selected
    }
    else{
      this.OTARights=false;
      this.selected=0;
    }
  }
  LicenseRightsChange(event){
    if(event.checked){
      this.LicensingRights=true
      this.LicenseRole=1
    }
    else{
      this.LicensingRights=false
      this.LicenseRole=0
    }
  }
  ExpandProductRightsColumn(){
    this.isProductRightsColumnExpanded=(this.isProductRightsColumnExpanded==null)?true:null;
  }
  ExpandLicenseRightsColumn(){
    this.isLicenseRightsColumnExpanded=(this.isLicenseRightsColumnExpanded==null)?true:null;
  }
  CheckAllProductOptions() {
    if (this.chkAllProduct) {
      this.productData.forEach((val) => {
        val.checked = true;
        val.Addchecked = true;
        val.ActiveInactiveChecked = true;
        val.Approvechecked = true;
      });
      this.productAdd = true;
      this.productDelete = true;
      this.productApprove = true;
    }

    if (this.productData.every((val) => val.checked)) {
      this.chkAllProduct = false;
      this.productData.forEach((val) => {
        val.checked = false;
        val.Addchecked = false;
        val.ActiveInactiveChecked = false;
        val.Approvechecked = false;
      });
      this.productAdd = false;
      this.productDelete = false;
      this.productApprove = false;
    } else {
      this.chkAllProduct = true;
      this.productData.forEach((val) => {
        val.checked = true;
        val.Addchecked = true;
        val.ActiveInactiveChecked = true;
        val.Approvechecked = true;
      });
      this.productAdd = true;
      this.productDelete = true;
      this.productApprove = true;
    }
  }

  changeproductvalue(i) {
    if (this.productData[i].checked) {
      this.productData[i].Addchecked = true;
      this.productData[i].ActiveInactiveChecked = true;
      this.productData[i].Approvechecked = true;
    } else {
      this.productData[i].Addchecked = false;
      this.productData[i].ActiveInactiveChecked = false;
      this.productData[i].Approvechecked = false;
    }
  }
  getInstrument() {
    this.productService.getReleaseProductsList().subscribe((data) => {
      this.productData = data.DataObject;
      for (let row of this.productData) {
        row.checked = false;
        row.Addchecked = false;
        row.ActiveInactiveChecked = false;
        row.Approvechecked = false;
        row.isDirtyAddchecked = false;
        row.isDirtyActiveInactiveChecked = false;
        row.isDirtyApprovechecked = false;
      }
    });
  }
  getLicenseProducts(){
    this.licenseService.getLicensePortalProducts().subscribe((data)=>{
      if(!data.IsError && data.DataObject!=null){
        this.licenseProducts=data.DataObject;
        for(let row of this.licenseProducts){
          row.IsAddEdit=false;
          row.IsDelete=false;
        }
      }
      else{

      }
    })
  
  }

  checkornot() {
    return false;
  }

  checkDevValue(type: number, value: boolean, product: any) {
    
    if (this.loggeduserrole != type) {
      let message = "";
      let buttontxt = "";

      if (value == true) {
        // Grant
        message =
          "Are you aware of the potential risks associated with granting access to the another department, and do you accept full responsibility for any issues that may arise?";
        buttontxt = "Accept";
      } else {
        // Revoke
        message =
          "Revoking access for other departments can potentially disrupt workflow and impact the user's ability to perform their duties. It is recommended to consult with the respective department administrator for their input and approval on this change.";
        buttontxt = "Continue";
      }

      swal
        .fire({
          title:
            "<strong style='color: red;'>Bypassing Established Workflows</strong>",
          icon: "info",
          html:
            `
        <p>` +
            message +
            `</p>
        <b>Please confirm your action:</b>
        <ul>
        <li style="margin-top:10px;"><b>` +
            buttontxt +
            `:</b> Proceed with the authorization change despite the recommendation.</li>
        <li><b>Cancel:</b> Restore the original settings and consult with the department administrator.</li>
        </ul>
        `,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: buttontxt,
          confirmButtonAriaLabel: buttontxt,
          cancelButtonText: `Cancel`,
          cancelButtonAriaLabel: "Cancel",
        })
        .then((result) => {
          if (!result.isConfirmed) {
            this.productData.forEach((element) => {
              if (element.ProductId == product.ProductId) {
                if (type == 1) {
                  element.Addchecked = value == true ? false : true;
                } else if (type == 2) {
                  element.Approvechecked = value == true ? false : true;
                } else if (type == 3) {
                  element.ActiveInactiveChecked = value == true ? false : true;
                }
              }
            });
          } else {
            this.productData.forEach((element) => {
              if (element.ProductId == product.ProductId) {
                if (type == 1) {
                  element.isDirtyAddchecked = true;
                } else if (type == 2) {
                  element.isDirtyActiveInactiveChecked = true;
                } else if (type == 3) {
                  element.isDirtyApprovechecked = true;
                }
              }
            });
          }
        });
    } else {
      this.productData.forEach((element) => {
        if (element.ProductId == product.ProductId) {
          if (element.ProductId == product.ProductId) {
            if (type == 1) {
              element.isDirtyAddchecked = true;
            } else if (type == 2) {
              element.isDirtyActiveInactiveChecked = true;
            } else if (type == 3) {
              element.isDirtyApprovechecked = true;
            }
          }
        }
      });
    }
  }

  getUserDetail(UserId) {
    this.userService.getUserById(UserId).subscribe((Data) => {
      console.log(Data)
      this.IsAdmin = Data.IsAdmin;
      this.selected = Data.Role;
      this.Oldselected = Data.Role;
      this.LicenseRole=Data.LicenseRole;
      let OTARightsSelected=(Data.PortalAccess==PortalAccess['OTA'] || Data.PortalAccess==PortalAccess['All'])?true:false
      let LicensingRightSelected=(Data.PortalAccess==PortalAccess['LicensingAndAdv'] || Data.PortalAccess==PortalAccess['All'])?true:false
      this.validationForm.patchValue({
        Name: Data.Name,
        EmailId: Data.EmailId,
        IsAdmin: Data.IsAdmin,
        Role: Data.Role,
        OTARights:OTARightsSelected,
        LicensingRights:LicensingRightSelected
      });
    });
  }
  userRights(UserId) {
    this.userService.getUserRights(UserId).subscribe((Data) => {
      if (!Data.IsError && Data.DataObject != "") {
        for (let row of Data.DataObject) {
          for (let col of this.productData) {
            if (col.ProductId == row.ProductId) {
              this.CheckRights(row, col);
            }
          }
        }

        if (!this.flagInstrument) this.chkAllProduct = true;
        else this.chkAllProduct = false;
      } else {
        this.errorMessage = Data.Error;
      }
    });
  }
  getUserAllRights(UserId){
    this.userService.getUserAllRightsById(UserId).subscribe((data)=>{
      if(!data.IsError && data.DataObject!=null){
        for(let row of data.DataObject){
          if(row.LicenseProductId){
            for(let product of this.licenseProducts){
              if(product.ProductId==row.LicenseProductId){
                this.checkLicenseRights(row,product)
              }
            }
          }
          if(row.ProductId){
            for (let product of this.productData) {
              if (product.ProductId == row.ProductId) {
                this.CheckRights(row, product);
              }
            }
          }
        }
      }
    })
  }
  checkLicenseRights(row,product){
    if(row.LicenseAddEditRight){
      product.IsAddEdit=true;
    }
    if(row.LicenseDeleteRight){
      product.IsDelete=true;
    }
  }
  CheckRights(row, col) {
    if (row.IsAdd) col.Addchecked = true;
    else this.flagInstrument = true;

    if (row.IsEdit) col.Editchecked = true;
    else this.flagInstrument = true;

    if (row.IsActiveInactive) col.ActiveInactiveChecked = true;
    else this.flagInstrument = true;

    if (row.IsApproveReject) col.Approvechecked = true;
    else this.flagInstrument = true;

    if (row.IsAdd && row.IsEdit && row.IsActiveInactive && row.IsApproveReject)
      col.checked = true;
  }

  onSubmit(): void {
    if(this.validationForm.value.OTARights && this.validationForm.value.LicensingRights){
      this.portalAccess=PortalAccess['All']
    }
    else if(this.validationForm.value.OTARights){
      this.portalAccess=PortalAccess['OTA']
    }
    else if(this.validationForm.value.LicensingRights){
      this.portalAccess=PortalAccess['LicensingAndAdv']
    }
    else{
      Swal.fire({
          title:"Please select atleast one user right",
          showCloseButton:true,
          showConfirmButton:true,
          confirmButtonText:"OK",
      });
      return;
    }
    this.appLoaderService.open();
    this.submitted = true;

    // stop the process here if form is invalid
    // if (this.validationForm.invalid) {
    //     return;
    // }

    // Check Email Id Already Exists or Not
    this.userService
      .getUsersByData(this.validationForm.value.EmailId, this.UserId)
      .subscribe((data) => {
        if (data.IsError) {
          this.appLoaderService.close();
          swal
          .fire({
            title: "<strong> Warning</strong>",
            icon: "warning",
            html:              `
            <p>` +
            data.Error +
            ` </p>`,
            showCloseButton: false,            
            focusConfirm: false,
          })
          .then((result) => {                          
              this.validationForm.patchValue({
                EmailId: ''
            });            
          });         
        } else {
          this.errorMessage = "";
          this.SaveUserDetail();
        }
      });  
  }

  oneditcancel(): void {
    this.UserId = 0;
    this.router.navigate(["user-management/user"]);
  }



  EditUserDetail(row) {
    this.UserId = row.UserId;
    this.validationForm.patchValue({
      Name: row.Name,
      EmailId: row.EmailId,
    });
  }

  checkCheckBoxvalue(event) {
    this.IsAdmin = event.checked;
  }

  SaveUserDetail(): void {
    this.productData.forEach((obj) => {
      this.newDynamicInstrument = {
        ProductId: obj.ProductId,
        IsAdd: obj.Addchecked,
        IsActiveInactive: obj.ActiveInactiveChecked,
        IsApproveReject: obj.Approvechecked,
      };
      this.userRightsArray.push(this.newDynamicInstrument);
    });

    //licensing rights array
    this.licenseProducts.forEach((product)=>{
      this.licenseRightsArray.push({
        ProductId:product.ProductId,
        IsAddEdit:product.IsAddEdit,
        IsDelete:product.IsDelete
      })
    });

    
    if (this.UserId == 0) {
      let model = {
        UserId: 0,
        Name: this.validationForm.value.Name.trim(),
        EmailId: this.validationForm.value.EmailId.trim(),
        UserRights: this.userRightsArray,
        LicensingRights:this.licenseRightsArray,
        IsAdmin: this.IsAdmin,
        Role: this.selected,
        LicenseRole: this.LicenseRole,
        PortalAccess:this.portalAccess,
        CreatedBy: Number(localStorage.getItem("userid")),
        UpdatedBy: Number(localStorage.getItem("userid")),
      };
      this.userService.addUser(model).subscribe(
        (data) => {
          if (!data.IsError && data.DataObject != null) {
            this.validationForm.patchValue({
              Name: "",
              EmailId: "",
              IsAdmin: false,
              Role: 1,
            });
            this.selected = 1;
            this.userRightsArray = [];
            this.licenseRightsArray=[];
            this.LicenseRole=0;
            this.portalAccess=0;
            this.newDynamicInstrument = {};
            this.appLoaderService.close();
            this.snackBar.open("User Rights Created Successfully", "", {
              duration: 2000,
            });
            this.userService.notifyOther({
              option: "onSave",
              value: "User Rights Successfully",
            });
            this.router.navigate(["/user-management/user"]);
          }
          else{
            this.appLoaderService.close();
          }
        },
        (_error: any) => {
          this.appLoaderService.close();
        }
      );
    } else {
      let model = {
        UserId: Number(this.UserId),
        Name: this.validationForm.value.Name.trim(),
        EmailId: this.validationForm.value.EmailId.trim(),
        UserRights: this.userRightsArray,
        LicensingRights:this.licenseRightsArray,
        IsAdmin: this.IsAdmin,
        Role: this.selected,
        LicenseRole: this.LicenseRole,
        PortalAccess:this.portalAccess,
        CreatedBy: Number(localStorage.getItem("userid")),
        UpdatedBy: Number(localStorage.getItem("userid")),
      };
      console.log(model)
      this.userService.updateUser(model).subscribe(
        (data) => {
          if (!data.IsError && data.DataObject != null) {
            this.validationForm.patchValue({
              Name: "",
              EmailId: "",
              IsAdmin: false,
              Role: 1,
            });
            this.selected = 1;
            this.userRightsArray = [];
            this.licenseRightsArray=[];
            this.LicenseRole=0;
            this.portalAccess=0;
            this.newDynamicInstrument = {};
            this.appLoaderService.close();
            this.snackBar.open("User Rights Updated Successfully", "", {
              duration: 2000,
            });
            this.userService.notifyOther({
              option: "onSave",
              value: "User Rights Successfully",
            });
            this.router.navigate(["/user-management/user"]);
          }
          else{
            this.appLoaderService.close();
          }
        },
        (_error: any) => {
          this.appLoaderService.close();
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-management/add-edit-user/adduser.component.ts